import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { createI18n } from 'vue-i18n'

import App from './App.vue'
import router from './router'
import './assets/main.css' // 保留默认样式

// 导入语言包
import tc from './locales/tc.json'
import cn from './locales/cn.json'
import en from './locales/en.json'

const messages = {
  'tc': tc,
  'cn': cn,
  'en': en
}

// 初始化 i18n
const i18n = createI18n({
  locale: 'tc', // 默认语言为繁体中文
  fallbackLocale: 'tc',
  messages,
})

const app = createApp(App)

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(i18n)

app.mount('#app')
